import React, { useRef, useState, ReactNode } from 'react';

import { tabContext } from 'contexts/tabContext';

function TabProvider({ children }: { children: ReactNode }): JSX.Element {
  const [idTab, setIdTab] = useState<number | null>(null);
  const tabsRef = useRef<Element>(null);

  const scrollToTabs = (id?: number) => {
    if (tabsRef.current) {
      tabsRef.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      const elementMobile = document.getElementById(`${id}-header`);
      if (elementMobile) {
        elementMobile.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <tabContext.Provider
      value={{ idTab: idTab, setIdTab, tabsRef, scrollToTabs }}
    >
      {children}
    </tabContext.Provider>
  );
}

export default TabProvider;
